import { ControlledTextInput } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useAppSelector } from 'shared/lib';
import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

import { selectIsRestorePage } from 'entities/siteSettings';
import { isLoggedSelector } from 'entities/user';

export const EmailAutocomplete: FC<IFieldFactoryProps> = (props) => {
  const { type, label = '' } = props;
  const isAuth = useAppSelector(isLoggedSelector);
  const isRestorePage = useAppSelector(selectIsRestorePage);
  const validate = useValidateOnBlur(type);

  return (
    <ControlledTextInput
      {...props}
      name={type}
      label={label}
      type="email"
      onBlur={validate}
      disabled={isRestorePage && !isAuth}
    />
  );
};
